/* eslint-disable react/no-unescaped-entities */
export const HOST_YOUR = "Host Your";
export const SECRET_SANTA = "Secret Santa";
export const SECRET_SANTA_DESCRIPTION = "Create a group, invite friends, and send gifts across locations — with FNP!";
export const CREATE_GROUP = "Create Secret Santa Group";
export const JOIN_EXISTING_GROUP = "Join Now";
export const HOW_IT_WORKS = "How it works?";
export const HOW_STEPS = [
  {
    imgSrc: "/icons/UsersFour.svg",
    title: "Create a Group",
    description: "Set up your Secret Santa group and invite your friends & family to join.",
  },
  {
    imgSrc: "/icons/ShieldCheckSanta.svg",
    title: "Pick a Name",
    description: "Once everyone joins, our game will anonymously assign each person a Secret Santa.",
  },
  {
    imgSrc: "/icons/GiftSanta.svg",
    title: "Exchange Your Gifts",
    description: "Send a gift to your assigned person, and keep the festive fun (and mystery!) alive.",
  },
];

export const SETUP_YOUR_GROUP = "Setup Secret Santa";
export const SETUP_DESCRIPTION = "Your are almost there! Just name your Secret Santa Group";
export const GROUP_NAME_PLACEHOLDER = "Enter your group name* e.g. Christmas2025";
export const LOGIN_TO_CONTINUE = "Login To Continue";
export const SAVE_ADDRESS_TO_CONTINUE = "Save & Create Board";
export const ENTER_DATE_PLACEHOLDER = "Secret Santa Reveal Date";
export const CALENDAR_PLACEHOLDER = "Select the date on which all your friends get to know who their Secret Santa was.";
export const SAVE_AND_CREATE_GROUP = "Save and Create Group";
export const SECRET_SANTA_REVEAL = "Secret Santa Reveal Date";
export const GROUP_INVITE_DETAILS = [{ title: "Group invite details", description: "vansh" }];
export const WELCOME_TO_SECRET_SANTA = "Welcome to Secret Santa 🎅🏻";
export const ADDR_DESCRIPTION = "As one of your friend will be sending a surprise gift share your delivery details.";
export const SANTA_YOUR_DETAILS = "Your Details";
export const SANTA_DELIVERY_DETAILS = "Delivery details";
export const SANTA_JOIN_DESCRIPTION = "Please enter secret passcode to join the group:";
export const ASSIGN_SECRET_SANTA = "Assign Secret Santa";
export const NEW_GROUP = "New Group";
export const MY_GROUPS = "My Groups";
export const SANTA_TAG_LINE =
  "Your Group is ready to share! Copy the link and passcode below and send it to your friends and family.";
export const SHARE_NOW = "Share Invite";
export const MIN_USERS = "We need minimum 3 members to play Secret Santa.";
export const CLICK_TO_SAVE_ADDRESS = "Click To Save Address ";

/** */
export const SAVE_ADDRESS_DESCRIPTION = (name) => {
  return (
    <p className="text-12 text-[#45556C]">
      You're <span className="inter text-12 text-emerald-600">{name}</span>'s Secret Santa. We’ve already saved the
      address for you to send gift.
    </p>
  );
};

export const HOHO_TEXT = "Ho Ho Ho!";
export const SAVE_ADDRESS_AND_SEND_GIFT = "Send Gift Now";
export const SEND_GIFT = "Send Gift";
export const MIN_USER_TOAST_MSG = "Atleast 3 members is required to assign Secret Santa.";
export const ADDRESS_SAVED_TOAST_MSG = "Address saved successfully! Redirecting...";
export const SANTA_REDIRECTION_URL = "/secret-santa-gifts-lp";
export const TRENDING_GIFTS_TITLE = "Trending on Christmas";
export const santaTrendingProducts = "santaTrendingProducts";
export const REVEAL_SANTA = "View My Secret Santa";
export const REVEAL_SANTA_DESCRIPTION = "Secret Santa for everyone is revealed 🥳";
export const REVEALED_SANTA_TAGLINE = "Secret Santas have been revealed. Check who’s your Secret Santa 🎅🏻";
export const textForMemberOnDashBoard =
  "You are already part of this group. Hang tight — the Admin will soon reveal who you'll be gifting.";
export const afterAssignText = "Ho ho ho! Secret Santas are busy picking gifts and sending surprises.";
export const YOUR_SANTA_IS = "Your Secret Santa is";
export const SANTA_ASSIGNED_MSG = "Secret Santa are Assigned Successfully.";
export const SANTA_FAQ_HEADING = "Frequently Asked Questions";
export const SANTA_FAQ = [
  {
    ques: "What is a Secret Santa game?",
    ans: "The Secret Santa game by FNP is an online tool that helps you instantly draw names for Secret Santa without any manual effort. Instead of picking chits from a bowl, the Secret Santa creator assigns gift recipients automatically. It keeps the entire process organised, fair, and fun. this makes it an ideal tool for offices, family gatherings, and festive celebrations.",
  },
  {
    ques: "How does the Secret Santa game work?",
    ans: "The Secret Santa game by FNP works in a very simple way. You first name the group and log in to enter the names of the people who are taking part in the Secret Santa game. Once all names are added, the tool shuffles them and completes the name draw for Secret Santa automatically. Each person receives the name of the person they will gift, and all matches are shared privately. This keeps the process organised and avoids mistakes or repeated names. You don’t need any special setup as the online Secret Santa game on FNP does all the work for you.",
  },
  {
    ques: "Is the Secret Santa Game anonymous? Can we reveal at the end?",
    ans: "Yes, the  FNP Secret Santa game is 100% anonymous. No one can see who got whose name during the draw. Every participant receives their match privately, which keeps the surprise intact. If your group wants to reveal the names at the end, you can do that during the gift exchange. Many people enjoy adding a final reveal moment to the Secret Santa game, but it is completely your choice.",
  },
  {
    ques: "Is this Secret Santa game free to use?",
    ans: "Yes, the FNP Secret Santa game is completely free of cost. You can use it as many times as you want without any charges. This tool is perfect for groups and people who love to plan big and small family celebrations or a big office event. This tool helps you organise the name draw Secret Santa activity instantly, without any cost.",
  },
  {
    ques: "Can I organize a Secret Santa online for my office, family, or friends?",
    ans: "Yes, absolutely. Our online Secret Santa organizer is perfect for all kinds of groups ranging from office teams, friends, classmates, or family members. You can add as many participants as you need, and the this FNP tool will handle the full name draw smoothly. It’s especially useful for remote teams, big groups, or anyone who wants a quick and easy way to manage the draw without mixing up names.",
  },
  {
    ques: "How do I draw names for Secret Santa online?",
    ans: "Drawing names for Secret Santa online is very simple. All you have to do is open the FNP Secret Santa game,create a group, enter everyone’s names, and click to start the draw. The tool will instantly assign each person a recipient and share the results privately. There’s no need to write names on paper or worry about duplicate picks.",
  },
  {
    ques: "Can I buy and send Secret Santa gifts directly through FNP Secret Santa Game?",
    ans: "Yes, absolutely you can! Once you receive your assigned name, you can browse and order Secret Santa gifts directly from FNP. You will get an array of option to choose from that fit varied budgets as well. You can filter out the items you like and get them delivered to the secret santa baby's house as FNP offers quick delivery across India, making gifting easy and convenient.",
  },
  {
    ques: "Can the Secret Santa gift organizer track whether gifts have been sent?",
    ans: "Yes, the FNP Secret Santa gift game helps you track the gifts you have brought frm the website. Once you have placed the order, you get the opportunity to see the timeline of delivery. FNP ensures timely updates of the order status within the FNP website. Besides, once you place a gift order, you can always track its delivery through your FNP account.",
  },
  {
    ques: "Can we play Secret Santa remotely or with people in different cities?",
    ans: "Absolutely, the online Secret Santa game is perfect for remote teams, long-distance friends, or family members living in different cities. Everyone can join the group online, the name draw happens instantly, and gifts can be sent anywhere with FNP’s reliable delivery network. Besides, everyone get the opportunity to add their own address at the time of log in, so you know that the gifts reach the recipient anonymously keeping this game a secret that it is supoosed to be.",
  },
  {
    ques: "Can I use the FNP Secret Santa game for large groups?",
    ans: "Yes, the tool works well even for large groups. Whether your Secret Santa game has 5 people or 50, the name draw Secret Santa process stays fast and organised.",
  },
];
